<div class="dialog-title row">
    <span class="text-fw-700">Payment instruction |</span>&nbsp;Mandate
</div>
<div class="content">
    <div class="row mb-4">
        <div class="col-12 text-dark-blue">
            Would you like to use your existing {{ paymentModel.currency.code }} mandate '{{ paymentModel.recipientMandate?.name }}'
            for this trade?
        </div>
    </div>
    <div class="row">
        <div class="mb-2 col-12 col-md-6 offset-md-3">
            <button class="btn btn-md btn-block btn-greengo button-text-wrap" (click)="processPayWithMandate()" npFocusOutClicked>Pay your existing mandate '{{ paymentModel.recipientMandate?.name }}'</button>
        </div>
        <div class="mb-2 col-12 col-md-6 offset-md-3">
            <button class="btn btn-md btn-block btn-greengo button-text-wrap" (click)="normalPaymentProcess()">Pay another beneficiary</button>
        </div>
        <div class="mb-2 col-12 col-md-6 offset-md-3">
            <button class="btn btn-md btn-block btn-lead-50 button-text-wrap" (click)="closeDialogAll()">Finish</button>
        </div>
    </div>
</div>